import { trpc } from "../lib/api/trpc";

// Organization roles
export type OrgRole = "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
// Legacy roles for backward compatibility
export type UserRole = "ADMIN" | "USER";

export const usePermissions = () => {
  // @ts-ignore - tRPC type issues
  const { data: user } = trpc.auth.me.useQuery();

  const userRole = user?.role as OrgRole | UserRole;
  const isSuperAdmin = !!user?.isSuperAdmin;
  const hasOrgContext = !!user?.hasOrganization;

  // Individual role checks - check for both org roles and legacy roles
  const isAdmin = userRole === "ADMIN";
  const isOwner = userRole === "OWNER";
  const isMember = userRole === "MEMBER";
  const isViewer = userRole === "VIEWER";
  const isUser = userRole === "USER";

  // Permission checker function - accepts any string role
  const hasAccess = (allowedRoles: string[]): boolean => {
    if (!userRole) return false;
    return allowedRoles.includes(userRole);
  };

  return {
    userRole,
    isSuperAdmin,
    hasOrgContext,
    isAdmin,
    isOwner,
    isMember,
    isViewer,
    isUser,
    hasAccess,
    isLoading: !user,
  };
};
